import {
  ChangeDetectorRef,
  Component,
  computed,
  Input,
  model,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
} from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'common-markup-condition-chips',
  templateUrl: './markup-condition-chips.component.html',
  styleUrls: ['./markup-condition-chips.component.scss'],
  standalone: false,
})
export class MarkupConditionChipsComponent implements OnInit, OnChanges {
  @Input()
  control: FormControl;
  @Input()
  placeholder: string;
  @Input()
  options: { value: string | number; label: string }[];

  private optionMap: {
    [value: string | number]: { value: string | number; label: string };
  } = {};
  readonly selectedOptions = signal<
    { value: string | number; label: string }[]
  >([]);
  readonly currentText = model('');
  readonly filteredOptions = computed(() => {
    const currentText = this.currentText().toLowerCase();
    return currentText
      ? this.options.filter((option) =>
          option.label.toLowerCase().includes(currentText),
        )
      : this.options.slice();
  });

  ngOnInit() {
    this.control.valueChanges.subscribe((newOptionValues) => {
      const newSelectedOptions = newOptionValues?.map(
        (optionValue) => this.optionMap[optionValue],
      );
      this.selectedOptions.set(newSelectedOptions ?? []);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('options')) {
      this.optionMap = {};
      this.options.forEach((option) => (this.optionMap[option.value] = option));
    }
  }

  removeOption(optionValue: string | number) {
    this.selectedOptions.update((selectedOptions) => {
      const index = selectedOptions.findIndex(
        (option) => option.value === optionValue,
      );
      if (index < 0) {
        return selectedOptions;
      }

      selectedOptions.splice(index, 1);
      return [...selectedOptions];
    });

    const index = this.control.value.indexOf(optionValue);
    if (index < 0) {
      return;
    }

    this.control.value.splice(index, 1);
    this.control.updateValueAndValidity();
  }

  selectOption({ option }: MatAutocompleteSelectedEvent, chipInput): void {
    const selectedOption = this.options.find(
      (opt) => opt.value === option.value,
    );
    if (selectedOption === undefined) {
      return;
    }

    this.currentText.set('');
    option.deselect(true);
    chipInput.value = '';

    const isAlreadySelected = this.selectedOptions().some(
      (opt) => opt.value === option.value,
    );
    if (isAlreadySelected) {
      return;
    }

    this.control.value.push(selectedOption.value);
    this.control.updateValueAndValidity();
  }
}
